import { Component, OnInit, OnChanges } from '@angular/core';
import { ParamUrlService } from '@service/paramurl.service';
import { Router } from '@angular/router';
import { sysLastDoc } from '../_const/const';
import { LayoutService } from '../../layout/service/app.layout.service';
import { MessagesService } from '@core/_services/messages.service';
import { Tools } from '@service/tools';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'dashlastdoc',
    templateUrl: 'dashlastdoc.component.html',
    styleUrls: ['dashlastdoc.component.scss'],
})
export class DashLastDocComponent implements OnInit, OnChanges {
    public fr: any;
    public error = false;
    public nbDocs: number;
    public statLastDoc = false;
    public listColumns: any[];
    public resultDisplay: any;
    public nbRow = 100;
    public isDesktop: boolean = false;

    constructor(
        protected _messageService: MessagesService,
        private router: Router,
        private paramUrlService: ParamUrlService,
        private tools: Tools,
        private main: LayoutService,
        private translate: TranslateService
    ) {
        this.isDesktop = this.main.isDesktop();
    }

    public ngOnInit() {
        this.listColumns = this.getlistColumns();
        this.nbDocs = 50;
        this.execLastDoc(this.nbDocs);
    }

    public ngOnChanges() {}

    private async execLastDoc(aNbDocs) {
        let wRes;
        wRes = false;
        // wRes = await this.requestTools.getUserPref();
        // this.checkTools.checkError(wRes);
        // if (this.checkTools.getRes() === false) {
        //     this._messageService.addErrorMsg(this.checkTools.getMsg());
        //     return;
        // }

        this.statLastDoc = true; // convertStringToBoolean(getPref(wRes.data, 6, 'false').datapref);
        this.resultDisplay = [];
        wRes = await this.tools.getDashStat(aNbDocs, 'getlastviewdocs');
        if (wRes.success === true) {
            this.resultDisplay = wRes.resultDisplay;
        }
    }

    public onRowSelect(event) {
        if (event.data.acces === true) {
            this.paramUrlService.prepareUrlSys(sysLastDoc, this.resultDisplay, event.data.doc_docid);
            this.router.navigate(['/page-request-last']);
        }
    }

    private getlistColumns() {
        let wItem: any;
        let wColList = new Array();
        wItem = { header: this.translate.instant('Name'), field: 'doc_name', type: 'String' };
        wColList.push(wItem);
        wItem = { header: this.translate.instant('Access'), field: 'acces', type: 'boolean' };
        wColList.push(wItem);        
        wItem = { header: this.translate.instant('Date'), field: 'dateview', type: 'DateTime' };
        wColList.push(wItem);
        return wColList;
    }
}
